module.exports = __webpack_public_path__ + "img/screenshot-26health.55b0cf4e.png";